import { AppConfig as ApiConfig } from "@thepiquelab/web-api";

const Auth0Connection = process.env.REACT_APP_AUTH0_CONNECTION;

/** Staff sign in with an emailed code rather than a password. */
export const IsPasswordlessLogin = !!Auth0Connection;

export const Auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_API_AUDIENCE_CORE_SERVICE,
    redirect_uri: window.location.origin ?? "http://localhost:3000",
    scope: process.env.REACT_APP_AUTH0_SCOPES,
    ...(Auth0Connection ? { connection: Auth0Connection } : {}),
  },
};

export const IsPermissionDebugMode =
  process.env.REACT_APP_PERMISSION_DEBUG_MODE === "true";
export const AppConfig = {
  UserServiceUrl: ApiConfig.getUserServiceUrl(),
  redirectPathname:
    process.env.REACT_APP_REDIRECT_PATH || window.location.pathname,
};

// @ts-ignore
export const IsPoweredByQianKun = window.__POWERED_BY_QIANKUN__;

export const Environment = process.env.REACT_APP_NODE_ENV || "local";
